<template>
	<div>
		<filter-panel :data="groups" @search="filterChange"></filter-panel>

		<data-list
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="columns"
			:loading="loading"
			:page="page"
			:page-size="page.pageSize"
			:selection="true"
			:btnList="btnList"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
			@selection-change="selectionChange"
		></data-list>

		<!-- 批量设置服务人员 -->
		<batchAppointForm ref="batchAppointForm" dialogWidth="500px" title="选择服务人员" />

		<!-- 预览模态框 -->
		<carousel-dialog
			:dialog="carouselDialog"
			:carousel="carousel"
			@carouseChange="carouseChange"
			@confirm="submit"
		>
			<el-row class="auto-trigger">
				<el-col :span="24" class="title">确认提示</el-col>
				<el-col :span="24" class="message">
					您当前的操作会触发{{ autoTriggerData.length }}条自动通知，通知内容如下
				</el-col>
				<el-col :span="24" class="content">
					<div class="content-item">
						<span class="item-name">邮件标题：</span>
						<div class="data">{{ activeTrigger.title }}</div>
					</div>
					<div class="content-item">
						<span class="item-name">收件人：</span>
						<div class="data">
							<span v-for="(item, index) in activeTrigger.recipientList" :key="index"
								>{{ item }}
							</span>
						</div>
					</div>
					<div class="content-item">
						<span class="item-name">抄送人：</span>
						<div class="data">
							<span v-for="(item, index) in activeTrigger.ccPeopleList" :key="index"
								>{{ item }}
							</span>
						</div>
					</div>
					<div class="content-item">
						<span class="item-name">附件：</span>
						<div class="data">
							<div
								v-for="(item, index) in activeTrigger.fileList"
								:key="index"
								class="accessory"
								@click="accessoryUrl(item.url)"
							>
								{{ item.url }}
							</div>
						</div>
					</div>
					<div class="content-item">
						<span class="item-name">内容：</span>
						<div class="information" v-html="activeTrigger.content"></div>
					</div>
				</el-col>
			</el-row>
		</carousel-dialog>
	</div>
</template>

<script>
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel';
import { serviceList, taskStatus } from '@/common/dictionary';
import orderDetail from '@/components/task/taskList/orderDetail';
import detailBtn from '@/components/task/taskList/detailBtn';
import popover from '@/components/task/taskList/popover';
import customer from '@/mixins/customer';
import beforeRouteEnter from '@/mixins/beforeRouteEnter.js';
import editText from '@/components/tools/edit_text';
import task from '@/backend/services/task/task.js';
import setmeal from '@/backend/services/account/setmeal.js';
import carouselDialog from '@/components/task/carouselDialog/carouselDialog';
import batchAppointForm from './batchAppointForm';

const page = listPageCreate({
	searchConfig: {
		api: api.task.getTaskList,
		method: 'POST',
	},
	getQuery(obj) {
		if (typeof obj.retrieval == 'undefined') {
			obj.retrieval = 1;
		}
		return obj;
	},
});
export default {
	name: 'taskList',
	mixins: [page, customer, beforeRouteEnter],
	components: {
		filterPanel,
		carouselDialog,
		batchAppointForm,
	},
	data() {
		const that = this;
		const columns = [
			{
				label: '任务类型',
				type: 'custom',
				componentName: detailBtn,
				query(row) {
					return { id: row.id };
				},
				bind: 'name',
			},
			{
				label: '客户名称',
				type: 'custInfo',
				text: [
					{
						bind: 'customerName',
					},
				],
				minWidth: 100,
			},
			{
				label: '订单编号/服务单号',
				type: 'multilineListItems',
				itemsList: [
					{
						label: '订单编号',
						type: 'custom',
						componentName: orderDetail,
						bind: 'orderCode',
						waiterNameBind: 'waiterName',
						salesNameBind: 'salesName',
					},
					{
						label: '服务单号',
						bind: 'serviceCode',
					},
				],
			},
			{
				label: '服务人员',
				bind: 'appointorName',
				type: 'custom',
				componentName: editText,
				config: {
					componentType: 'userSearch',
				},
				triggerEvent(row, data, cb) {
					if (data !== '') {
						that.triggerType = 'appointor';
						that.triggerVal = '4';
						that.triggerId = row.id;
						that.triggerData = data;
						that.previewInform(cb);
					}
				},
			},
			{
				label: '任务截止时间',
				bind: 'expirationDate',
				type: 'custom',
				componentName: editText,
				config: {
					componentType: 'el-date-picker',
					type: 'date',
					'value-format': 'yyyy-MM-dd',
				},
				triggerEvent(row, data, cb) {
					if (data !== '') {
						that.triggerType = 'expirationDate';
						that.triggerVal = '4';
						that.triggerId = row.id;
						that.triggerData = data;
						that.previewInform();
					}
				},
			},
			{
				label: '业务线',
				bind: 'businessLineName',
			},
			{
				label: '子任务',
				bind: ['finishCount', 'count'],
				type: 'custom',
				componentName: popover,
				popover: {
					placement: 'right',
					width: 230,
				},
				dataStyle(row) {
					return row.finishCount + '/' + row.count;
				},
				subData(row) {
					return row.subTaskList;
				},
			},
			{
				label: '状态',
				bind: 'statusName',
				type: 'custom',
				align: 'center',
				componentName: editText,
				config: {
					componentType: 'sky-select',
					options: taskStatus,
				},
				style: {
					justifyContent: 'center',
				},
				showButton() {
					return that.getPermission(that.$permissionData.ChangesEdit.englishName);
				},
				triggerEvent(row, data, cb) {
					if (data !== '') {
						that.triggerType = 'status';
						that.triggerVal = data;
						that.triggerId = row.id;
						that.triggerData = data;
						that.previewInform();
					}
				},
				getClass(row) {
					let status = taskStatus.find(item => row.status === item.value);
					return `text-${status.class}`;
				},
			},
		];
		return {
			columns: columns,
			groups: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '订单查询',
						label: '订单查询',
						options: [],
						prop: 'orderCode',
						value: '',
					},
					{
						tagName: 'sky-mainInput',
						placeholder: '任务查询',
						label: '任务查询',
						prop: 'name',
						value: '',
					},
					{
						tagName: 'sky-mainInput',
						placeholder: '服务人员查询',
						label: '服务人员查询',
						prop: 'appointorName',
					},
					{
						tagName: 'sky-date-picker',
						type: 'daterange',
						label: '截止日期范围',
						startPlaceholder: '截止开始日期',
						endPlaceholder: '截止结束日期',
						prop: ['startDate', 'endDate'],
						value: [],
					},
					{
						tagName: 'sky-mainInput',
						placeholder: '服务单号',
						label: '服务单号',
						prop: 'serviceCode',
						value: '',
					},
				],
				multiples: [
					{
						defaultText: '业务线',
						placeholder: '业务线',
						label: '业务线',
						options: [],
						prop: 'businessLineId',
						props: {
							label: 'name',
							value: 'id',
						},
						value: '',
					},
					{
						defaultText: '任务状态',
						placeholder: '任务状态',
						label: '任务状态',
						options: taskStatus,
						prop: 'status',
						multiple: true,
						value: [],
					},
					{
						defaultText: '任务类型',
						placeholder: '任务类型',
						label: '任务类型',
						prop: 'type',
						value: '',
						options: serviceList,
					},
					{
						defaultText: '任务',
						label: '任务',
						prop: 'retrieval',
						value: 1,
						options: [
							{
								label: '我的全部任务',
								value: 1,
							},
							{
								label: '我未完成的任务',
								value: 2,
							},
							{
								label: '我待开始的任务',
								value: 3,
							},
							{
								label: '我进行中的任务',
								value: 4,
							},
						],
					},
				],
			},
			btnList: [
				{
					name: '设置服务人员',
					position: 'left',
					attribute: {
						type: 'primary',
						size: 'small',
						loading: false,
					},
					async btnClick() {
						let { tableRow } = that;
						let { cancel } = await that.$refs.batchAppointForm.show({
							tableRow,
						});
						if (!cancel) {
							that.query();
						}
					},
				},
			],
			// 模态框配置
			carouselDialog: {
				width: '45%',
				visible: false,
			},
			// 走马灯配置
			carousel: {
				height: '400px',
				autoplay: false,
				arrow: 'always',
				indicator: 'outside',
				data: [],
			},
			autoTriggerData: [],
			activeTrigger: {},
			tableRow: [],
		};
	},
	methods: {
		submit() {
			let id = this.triggerId;
			let type = this.triggerType;
			let value = this.triggerData;
			task
				.editTaskDetail(id, {
					[type]: value,
				})
				.then(val => {
					this.$message({
						message: '修改成功',
						type: 'success',
					});
					this.query();
				});
		},
		async filterData() {
			let res = await setmeal.getserveList();
			this.groups.multiples[0].options = res.data;
		},
		// 幻灯片切换
		carouseChange(index, oldIndex) {
			this.activeTrigger = this.autoTriggerData[index];
		},
		// 触发预览
		async previewInform(callback) {
			let type = this.triggerType;
			let val = this.triggerVal;
			let id = this.triggerId;
			switch (type) {
				case 'leader':
					type = 'LEADER';
					break;
				case 'appointor':
					type = 'ASSIGNED_TO';
					break;
				case 'expirationDate':
					type = 'EXPIRATION_DATE';
					break;
				case 'status':
					type = 'TASK_STATUS';
					break;
			}
			switch (val) {
				case 1:
					val = 'WAITING_TO_START';
					break;
				case 2:
					val = 'PROCESSING';
					break;
				case 3:
					val = 'FINISHED';
					break;
				default:
					val = 'CHANGE';
					break;
			}
			try {
				let res = await task.previewInform({
					conditionFieldEnum: type,
					conditionStatusEnum: val,
					taskId: id,
				});
				if (res.data.length == 0) {
					this.submit();
					callback && callback();
					return false;
				}
				if (res.data.length <= 1) {
					this.carousel.arrow = 'never';
					this.carousel.indicator = 'none';
				} else {
					this.carousel.arrow = 'always';
					this.carousel.indicator = 'outside';
				}
				this.autoTriggerData = res.data;
				this.activeTrigger = res.data[0];
				res.data.forEach((item, index) => {
					this.carousel.data.push({ label: index });
				});
				this.carouselDialog.visible = true;
			} catch (error) {
				console.log(error);
			}
		},
		// 跳转附件
		accessoryUrl(url) {
			window.open(url);
		},
		// 多选操作
		selectionChange(column) {
			this.tableRow = column;
		},
	},
	mounted() {
		this.filterData();
	},
};
</script>

<style lang="scss" scoped>
// 触发预览
.auto-trigger {
	width: 100%;
	height: 100%;
	font-size: 14px;
	color: #333;
	padding: 0 60px;
	.title {
		text-align: center;
		font-size: 18px;
	}
	.message {
		text-align: center;
		margin: 20px 0 30px;
	}

	.content {
		.content-item {
			margin-bottom: 15px;
			display: flex;
			.item-name {
				width: 80px;
				display: inline-block;
				text-align: right;
				margin-right: 20px;
			}
			.data {
				flex: 1;
				// 单行溢出
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				.accessory {
					cursor: pointer;
					color: #5aa0ff;
					margin: 5px;
				}
			}
			.information {
				max-height: 150px;
				flex: 1;
				word-break: break-all;
				overflow: auto;
				padding-right: 2px;
			}
			.information::-webkit-scrollbar {
				width: 5px;
				height: 1px;
			}
			.information::-webkit-scrollbar-thumb {
				border-radius: 2px;
				background: #e8e8e8;
			}
			.information::-webkit-scrollbar-track {
				border-radius: 2px;
				background: #fff;
			}
		}
	}
}
</style>
